import Image from 'next/image';

import { cn } from '@/lib/utils';
import { ComingSoonBadge } from '@/components/ui/comingSoonBadge';

export interface DecorativeCardProps {
  content: React.ReactNode;
  img: string;
  imgRotate: 'none' | 'left' | 'right';
  disabled?: boolean;
  comingSoon?: boolean;
}

const getRotationClass = (rotation: 'none' | 'left' | 'right'): string => {
  if (rotation === 'left') return 'rotate-12';
  if (rotation === 'right') return '-rotate-12';
  return '';
};

const DecorativeCard = ({
  content,
  img,
  imgRotate,
  disabled = false,
  comingSoon = false,
}: DecorativeCardProps) => {
  const isDisabled = disabled || comingSoon;

  return (
    <div
      className={cn(
        'relative flex justify-center items-center w-full h-36',
        isDisabled && 'pointer-events-none',
      )}
      style={{
        maxWidth: '360px',
        width: '80vw',
        minWidth: '320px',
      }}
    >
      <div className={cn(
        'flex justify-start h-28 items-center relative gap-2 bg-default-50 rounded-lg ps-2 py-2 w-full',
        isDisabled && 'grayscale',
      )}>
        {content}
      </div>
      <div className={cn(
        'absolute right-0 top-1/2 -translate-y-1/2 h-full flex items-center justify-center z-55',
        isDisabled && 'grayscale',
      )}>
        <Image
          src={img}
          alt="carta decorativa"
          width={100}
          height={100}
          className={`${getRotationClass(imgRotate)} object-contain h-[100px] w-[100px]`}
          style={{
            filter: 'drop-shadow(3px 8px 10px rgba(0, 0, 0, 0.5))',
          }}
          loading="lazy"
          quality={70}
          draggable={false}
        />
      </div>
      {comingSoon && (
        <ComingSoonBadge className="absolute top-0 right-0 z-60" />
      )}
      <div className={cn(
        'absolute right-0 inset-y-0 z-20',
        isDisabled && 'grayscale',
      )}>
        <svg xmlns="http://www.w3.org/2000/svg" width="89" height="240" viewBox="0 0 89 240" fill="none">
          <path d="M17.4586 11.2863C18.3495 5.51969 23.2594 1.22977 29.0935 1.12063L76.7756 0.228675C83.4896 0.103079 89 5.51133 89 12.2266V120.863C89 127.423 83.7326 132.767 77.1736 132.862L12.7015 133.795C5.27431 133.902 -0.465565 127.304 0.668555 119.964L17.4586 11.2863Z" fill="#9B64F2" />
        </svg>
      </div>
    </div>
  );
};

export default DecorativeCard;
